<template>
    <section class="c-boxes" :class="[background, spaces]" ref="$boxes">
        <div class="c-container">
            <h2 class="headline centered psb-60" v-html="nl2br(data.title)"></h2>
            <div class="c-boxes__grid" ref="$grid">
                <CardsBox v-for="info in data.boxes" :key="info.id" :data="info" />
            </div>
        </div>
    </section>
</template>

<script setup>
    const props = defineProps({
        data: {
            type: Object,
            default: {}
        },
        background: {
            type: String,
            default: "bg-white"
        },
        spaces: {
            type: String,
            default: "pst-100 psb-100 pst-md-150 psb-md-150"
        }
    });

    const { $gsap: gsap } = useNuxtApp();
    const $boxes = ref(null);
    const $grid = ref(null);
    const isDesktop = useMediaQuery("(min-width: 1181px)");

    useStartAnimations(() => {
        const boxes = $grid.value.querySelectorAll(".card-box");

        if (!!boxes.length) {
            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: $boxes.value,
                    start: "top 35%",
                    end: "bottom top",
                    once: true
                }
            });

            timeline.addLabel("startBoxes");

            boxes.forEach((box, index) => {
                gsap.set(box, {
                    opacity: 0,
                    yPercent: index % 2 == 0 ? -15 : isDesktop.value ? 15 : -15
                });

                timeline.to(
                    box,
                    {
                        opacity: 1,
                        yPercent: 0,
                        ease: "power1",
                        duration: 1
                    },
                    "startBoxes"
                );
            });
        }
    });
</script>
